import { TGridHeader, GridCell } from '.';

export default function Header({
  gridTemplateColumns,
  className = '',
  columns,
  scrollbarWidth,
}: {
  scrollbarWidth: number;
  gridTemplateColumns: string;
  className?: string;
  columns?: (string | TGridHeader)[];
}) {
  const gridHeaders: TGridHeader[] = (columns || [])?.map((_) =>
    typeof _ === 'string'
      ? { render: _, width: 'minmax(0, 1fr)' }
      : { ..._, width: _.width ? _.width : 'minmax(0, 1fr)' },
  );
  return (
    <div
      className={`grid rounded-t-lg rounded overflow-hidden ${className}`}
      style={{
        gridTemplateColumns,
        paddingRight: `${scrollbarWidth}px`,
      }}
    >
      {gridHeaders.map((column, index) => (
        <GridCell
          key={index}
          justifyContent={index === 0 ? 'start' : undefined}
          className={`${
            column.className || className
          }   font-semibold grid-header-cell`}
          border=""
        >
          {column.render}
        </GridCell>
      ))}
    </div>
  );
}
